
import React from 'react';
import { Route } from 'react-router-dom';
import Analytics from '@/pages/Analytics';
import DeviceHealth from '@/pages/DeviceHealth';
import TopKPIs from '@/pages/TopKPIs';
import KpiDetailRouter from '@/pages/kpi/KpiDetailRouter';
import Consumers from '@/pages/Consumers';
import Bills from '@/pages/Bills';
import Reports from '@/pages/Reports';

const energyRoutes = (
  <>
    <Route path="/energy/top-kpis" element={<TopKPIs />} />
    <Route path="/energy/analytics" element={<Analytics />} />
    <Route path="/energy/device-health" element={<DeviceHealth />} />
    <Route path="/energy/consumers" element={<Consumers />} />
    <Route path="/energy/bills" element={<Bills />} />
    <Route path="/energy/reports" element={<Reports />} />
    
    {/* KPI Detail Routes */}
    <Route path="/energy/kpi/:id" element={<KpiDetailRouter />} />
  </>
);

export default energyRoutes;
